<style lang="scss"></style>

<template>
  <div style="overflow: auto;height: 100%;position: relative;display: flex;flex-direction: column;">
    <div class="titleBar" style="display: flex;align-items:center ;position: sticky;top: 0;background: #202027;padding: 20px;padding-bottom: 14px;">
      <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
      <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
        {{ $t("jinnianhexinzhibiao") }}
      </p>
    </div>
    <div style="font-size: 16px;line-height: 22px;color: #F4F4F4;width:100%;text-align: center;">{{ $t("zonghe") }}OEE:{{ (((cockpitData.reportByYear.startupRate * cockpitData.reportByYear.runRate * cockpitData.reportByYear.badQuantityRate) / 1000000) * 100).toFixed(1) }}%</div>
    <div style="padding: 20px 40px;padding-top:0px;display: flex;justify-content: space-between;flex: 1;">
      <div style="width:30%;display: flex;flex-direction: column;align-items: center;justify-content: space-between;">
        <div>
          <img :src="require('@@/assets/img/web/cockpit/yibiaopan_lan/yibiaopan_lan_' + parseInt((cockpitData.reportByYear.startupRate * 41) / 100) + '.png')" style="width: 100%;height: auto" />
          <div style="margin-top: -44%;text-align: center;">
            <div style="color:white;font-weight:700px;font-size:28px">{{ cockpitData.reportByYear.startupRate }}%</div>
            <div style="color:white;font-weight:700px;font-size:16px">{{ $t("kaijilv") }}</div>
          </div>
        </div>
        <div style="margin-top: 0px;">
          <p style="font-size:16px;color:#C0C4CC;text-align: center;">
            <span>{{ $t("tongjishebei") }}</span>
            <span style="color:white;margin-left: 8px;">{{ cockpitData.reportByYear.equipmentCount }}台</span>
          </p>
          <p style="font-size:16px;color:#C0C4CC;text-align: center;margin-top: 8px;">
            <span>{{ $t("leijikaijishijian") }}</span>
            <span style="color:white;margin-left: 8px;">{{ cockpitData.reportByYear.startupDuration }}{{ $t("xiaoshi") }}</span>
          </p>
        </div>
      </div>
      <div style="width:30%;display: flex;flex-direction: column;align-items: center;justify-content: space-between;">
        <div>
          <img :src="require('@@/assets/img/web/cockpit/yibiaopan_lv/yibiaopan_lv_' + parseInt((cockpitData.reportByYear.runRate * 41) / 100) + '.png')" style="width: 100%;height: auto" />
          <div style="margin-top: -44%;text-align: center;">
            <div style="color:white;font-weight:700px;font-size:28px">{{ cockpitData.reportByYear.runRate }}%</div>
            <div style="color:white;font-weight:700px;font-size:16px">{{ $t("jiadonglv") }}</div>
          </div>
        </div>
        <div style="margin-top: 0px;">
          <p style="font-size:16px;color:#C0C4CC;text-align: center;">
            <span>{{ $t("leijikaijishijian") }}</span>
            <span style="color:white;margin-left: 8px;">{{ cockpitData.reportByYear.startupDuration }}{{ $t("xiaoshi") }}</span>
          </p>
          <p style="font-size:16px;color:#C0C4CC;text-align: center;margin-top: 8px;">
            <span>{{ $t("leijiyunxingshijian") }}</span>
            <span style="color:white;margin-left: 8px;">{{ cockpitData.reportByYear.runDuration }}{{ $t("xiaoshi") }}</span>
          </p>
        </div>
      </div>
      <div style="width:30%;display: flex;flex-direction: column;align-items: center;justify-content: space-between">
        <div>
          <img :src="require('@@/assets/img/web/cockpit/yibiaopan_zi/yibiaopan_zi_' + parseInt((cockpitData.reportByYear.badQuantityRate * 41) / 100) + '.png')" style="width: 100%;height: auto" />
          <div style="margin-top: -44%;text-align: center;">
            <div style="color:white;font-weight:700px;font-size:28px">{{ cockpitData.reportByYear.badQuantityRate }}%</div>
            <div style="color:white;font-weight:700px;font-size:16px">{{ $t("liangpinlv") }}</div>
          </div>
        </div>
        <div style="margin-top: 0px;">
          <p style="font-size:16px;color:#C0C4CC;text-align: center;">
            <span>{{ $t("leijibaogongshu") }}</span>
            <span style="color:white;margin-left: 8px;">{{ cockpitData.reportByYear.quantitySum }}{{ $t("jian") }}</span>
          </p>
          <p style="font-size:16px;color:#C0C4CC;text-align: center;margin-top: 8px;">
            <span>{{ $t("leijiliangpinshu") }}</span>
            <span style="color:white;margin-left: 8px;">{{ cockpitData.reportByYear.finishGoodQuantitySum }}{{ $t("jian") }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "web_monitor_cockpit_quota",
  components: {},
  props: {
    cockpitData: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  watch: {},
  destroyed() {
    clearInterval(this.timmer);
  },
  methods: {
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {}, 500);
    },
  },
};
</script>
